module.exports = __webpack_public_path__ + "index/img/avatar.b8ca6251.png";